import React from 'react'

const NoTableData = ({message} : any) => {
  return (
    <div className='d-flex py-4 align-items-center justify-content-center w-full lex-400-18 color-muted'>{message}</div>
  )
}

export default NoTableData